import { LayoutDashboard, Inbox, Building2, Monitor, FileText, Wallet, Users, Package, HardDrive, CalendarDays, Bell, Settings, UserRoundCog, Search, Plus, RefreshCw, ArrowUpRight, ChevronRight, SlidersHorizontal, List, Columns3, ShieldCheck, Network, Printer, Server, X, Check, Pencil, Trash2, Download, History, Mail, UserRound, Clock, Receipt, Menu, ChevronDown, LogOut, Sun, Moon, Flower2, BriefcaseBusiness, MonitorCog, FolderOpen } from 'lucide-react';

const icons = {
  overview:LayoutDashboard, tickets:Inbox, customers:Building2, equipment:Monitor,
  contracts:FileText, billing:Wallet, team:Users, services:FileText, parts:Package,
  assets:HardDrive, licenses:CalendarDays, purchases:Wallet, documents:FileText,
  notifications:Bell, settings:Settings, access:UserRoundCog, search:Search, plus:Plus,
  refresh:RefreshCw, arrow:ArrowUpRight, chevron:ChevronRight, filter:SlidersHorizontal,
  list:List, kanban:Columns3, shield:ShieldCheck, network:Network, printer:Printer,
  server:Server, close:X, calendar:CalendarDays, check:Check, edit:Pencil, trash:Trash2,
  download:Download, history:History, mail:Mail, user:UserRound, clock:Clock,
  briefcase:BriefcaseBusiness, 'monitor-cog':MonitorCog, folder:FolderOpen,
  receipt:Receipt, menu:Menu, down:ChevronDown, logout:LogOut, sun:Sun, moon:Moon, flower:Flower2,
};
export type IconName = keyof typeof icons;
export function Icon({name,size=18,className}:{name:IconName;size?:number;className?:string}) {
  const Component=icons[name];
  return <Component size={size} strokeWidth={1.7} className={className} aria-hidden="true" focusable="false"/>;
}
